import ActionType from "../../actions/aboutJingWei/ActionType";


const initialState={
    url:''
}

// const routerArr={
//     TO_ABOUT_US:'',
//     TO_FEATURE_SERVICE:'',
//     TO_PROJECT_EXAMPLE:'',
//     TO_PARTENER:'',
//     TO_CHAIRMAN_SPEAK:'',
//     TO_HONOR:'',
//     TO_MEMORABILIA:'',
//     TO_COMMENT:''
// };


const jwRouterReducer=(state=initialState,action={})=>{
    switch(action.type){
        case ActionType.TO_URL:
            return Object.assign({},state,{
                url:'/about',
            })
        default:
            return state;
    }
}

export default jwRouterReducer;
